import { useState } from 'react';
import { useSearch } from '@/hooks';
import { Input, Button, Card, CardContent } from '@/components/ui';
import { Search as SearchIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Search() {
  const [query, setQuery] = useState('');
  const [searchedQuery, setSearchedQuery] = useState('');
  const [page, setPage] = useState(1);

  const { data, isLoading } = useSearch(searchedQuery, { page, perPage: 10 });

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      setSearchedQuery(query.trim());
      setPage(1);
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">搜索</h1>

      <form onSubmit={handleSearch} className="flex space-x-2">
        <Input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="搜索页面..."
          className="flex-1"
        />
        <Button type="submit" disabled={isLoading}>
          <SearchIcon className="h-4 w-4 mr-2" />
          搜索
        </Button>
      </form>

      {searchedQuery && (
        <div className="space-y-4">
          <p className="text-muted-foreground">
            找到 {data?.total || 0} 个结果
          </p>

          {isLoading ? (
            <div className="space-y-4">
              {[1, 2, 3].map((i) => (
                <Card key={i}>
                  <CardContent className="py-4">
                    <div className="animate-pulse space-y-2">
                      <div className="h-4 bg-muted rounded w-1/2" />
                      <div className="h-3 bg-muted rounded w-full" />
                      <div className="h-3 bg-muted rounded w-3/4" />
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          ) : data?.results.length === 0 ? (
            <Card>
              <CardContent className="py-8 text-center text-muted-foreground">
                没有找到匹配的结果
              </CardContent>
            </Card>
          ) : (
            <div className="space-y-4">
              {data?.results.map((result) => (
                <Link key={result.id} to={`/pages/${result.slug}`}>
                  <Card className="hover:border-primary transition-colors">
                    <CardContent className="py-4">
                      <h3 className="font-semibold mb-2 hover:text-primary">
                        <span dangerouslySetInnerHTML={{ __html: result.highlighted_title }} />
                      </h3>
                      <p className="text-sm text-muted-foreground line-clamp-2">
                        <span dangerouslySetInnerHTML={{ __html: result.highlighted_content }} />
                      </p>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
          )}

          {/* Pagination */}
          {data && data.totalPages > 1 && (
            <div className="flex items-center justify-center space-x-2">
              <Button
                variant="outline"
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              >
                上一页
              </Button>
              <span className="text-sm text-muted-foreground">
                第 {page} / {data.totalPages} 页
              </span>
              <Button
                variant="outline"
                disabled={page === data.totalPages}
                onClick={() => setPage(page + 1)}
              >
                下一页
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
